/* SAMPLE COLLECTORS */
// get BANK
export const GET_BANK_LIST = "GET_BANK_LIST";
export const GET_BANK_LIST_SUCCESS ="GET_BANK_LIST_SUCCESS";
export const GET_BANK_LIST_FAIL = "GET_BANK_LIST_FAIL";
// Add BANK
export const ADD_NEW_BANK = "ADD_NEW_BANK";
export const ADD_NEW_BANK_SUCCESS = "ADD_NEW_BANK_SUCCESS";
export const ADD_NEW_BANK_FAIL = "ADD_NEW_BANK_FAIL";
//Update BANK
export const UPDATE_BANK = "UPDATE_BANK";
export const UPDATE_BANK_SUCCESS = "UPDATE_BANK_SUCCESS";
export const UPDATE_BANK_FAIL = "UPDATE_BANK_FAIL";